import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthGuardService } from './services/auth-guard.service';
import { SplashScreenComponent } from './splashScreen/splash-screen/splash-screen.component';
import { SurveyComponent } from './pages/survey/survey/survey.component';
import { ChangePasswordComponent } from './pages/login/change-password/change-password.component';
import { ResetPasswordComponent } from './pages/login/reset-password/reset-password.component';

const routes: Routes = [
  {
    path: 'splashScreen',
    component: SplashScreenComponent
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(module => module.LoginModule)
  },
  {
    path: '', redirectTo: '/splashScreen', pathMatch: 'full'
  },
  {
    path: 'changePassword',
    component: ChangePasswordComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'survey',
    component: SurveyComponent,
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'home/content',
        component: HomeComponent
      },
      {
        path: 'orders',
        loadChildren: () => import('./pages/orders/orders.module').then(module => module.OrdersModule)
      },
      {
        path: 'stocks',
        loadChildren: () => import('./pages/stocks/stocks.module').then(module => module.StocksModule)
      },
      {
        path: 'claims',
        loadChildren: () => import('./pages/claims/claims.module').then(module => module.ClaimsModule)
      },
      {
        path: 'product-usage-tracker',
        loadChildren: () => import('./pages/product-usage-tracker/product-usage-tracker.module').then(module => module.ProductUsageTrackerModule)
      },
      {
        path: 'notification',
        loadChildren: () => import('./pages/notification/notification.module').then(module => module.NotificationModule)
      },
      {
        path: 'maintenance',
        loadChildren: () => import('./pages/maintenance/maintenance.module').then(module => module.MaintenanceModule)
      },
      {
        path: 'dailymeals',
        loadChildren: () => import('./pages/dailymeals/dailymeals.module').then(module => module.DailyMealsModule)
      },
      {
        path: 'faq',
        loadChildren: () => import('./pages/faq/faq.module').then(module => module.FAQModule)
      },
      {
        path: 'info',
        loadChildren: () => import('./pages/info/info.module').then(module => module.InfoModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(module => module.DashboardModule)
      },
      {
        path: 'survey',
        loadChildren: () => import('./pages/survey/survey.module').then(module => module.SurveyModule)
      },
      {
        path: 'audits',
        loadChildren: () => import('./pages/audits/audits.module').then(module => module.AuditsModule)
      },
      {
        path: 'inventory-disposal',
        loadChildren: () => import('./pages/inventory-disposal/inventory-disposal.module').then(module => module.InventoryDisposalModule)
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'login',
  }
];

@NgModule({
  declarations: [],
  exports: [RouterModule],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, { useHash: true })
  ]
})
export class AppRoutingModule { }
